import { BinaryTree, BTMETA, BTTYPE } from "./binary-tree"
import { BinaryTreeEditNode } from "./binary-tree-edit-node"
import { CoordinatorService } from "./coordinator.service"

export type BTEPAR = {
    type?: BTTYPE,
    bt?: BinaryTree
}

export class BinaryTreeEdit {
    id: string
    meta?: BTMETA
    root: BinaryTreeEditNode
    private _bt: BinaryTree | undefined

    constructor(
        private coords: CoordinatorService,
        params: BTEPAR,
    ) {
        this.id = this.coords.uniqueId()
        let p: any
        if (params.bt) {
            this._bt = params.bt
            this.meta = Object.assign({}, this._bt.meta)
            p = this._bt.root.btenPar
            // this.root.createChildrenFromBinaryTreeNode(this._bt.root)
        }
        p.bte = this
        this.root = new BinaryTreeEditNode(this.coords, p)
    }


    confirm() {
       this._bt?.updateFromEditor(this)
       this.coords.display$.closeDialog()
       this.coords.display$.markForCheck()
    }

    get title() {
        return this.meta?.title || ""
    }

    set title(val: string) {
        this.meta!.title = val
    }


    // this.topLevelNodeLs =  this.binaryTree.topLevelNodeLs
    //   .map(btnd => this._bt$.createBinaryTreeEditNode(this, btnd))
}
